module.exports = __webpack_public_path__ + "img/60c481dbc19af6.80182065.dc78cbc5.png";